module.exports = __webpack_public_path__ + "img/ZonaMate_icone_Obiettivi_bianca.986e02d0.svg";